import { Controller } from "@hotwired/stimulus"

// Toggles approval assignee / quorum fields on task create form.
export default class extends Controller {
  static targets = [
    "fields",
    "enabled",
    "assigneeType",
    "personSelect",
    "groupSelect",
    "quorumFields",
    "quorumMode",
    "requiredCountWrap",
    "requiredCount"
  ]

  connect() {
    this.refresh()
  }

  refresh() {
    const enabled = this.hasEnabledTarget && this.enabledTarget.checked
    if (this.hasFieldsTarget) {
      this.fieldsTarget.classList.toggle("d-none", !enabled)
    }
    if (!enabled) return

    const type = this.hasAssigneeTypeTarget ? this.assigneeTypeTarget.value : "Person"
    const isGroup = type === "PersonGroup"

    if (this.hasPersonSelectTarget) {
      this.personSelectTarget.classList.toggle("d-none", isGroup)
      this.personSelectTarget.querySelectorAll("select, input").forEach((el) => {
        el.disabled = isGroup
      })
    }
    if (this.hasGroupSelectTarget) {
      this.groupSelectTarget.classList.toggle("d-none", !isGroup)
      this.groupSelectTarget.querySelectorAll("select, input").forEach((el) => {
        el.disabled = !isGroup
      })
    }
    if (this.hasQuorumFieldsTarget) {
      this.quorumFieldsTarget.classList.toggle("d-none", !isGroup)
      this.quorumFieldsTarget.querySelectorAll("input").forEach((el) => {
        el.disabled = !isGroup
      })
    }

    const mode = this.hasQuorumModeTarget
      ? this.quorumModeTargets.find((el) => el.checked)?.value
      : "all"
    const showCount = isGroup && mode === "minimum"
    if (this.hasRequiredCountWrapTarget) {
      this.requiredCountWrapTarget.classList.toggle("d-none", !showCount)
      // Keep flex alignment when visible (d-none alone would drop d-flex utility).
      this.requiredCountWrapTarget.classList.toggle("d-flex", showCount)
    }
    if (this.hasRequiredCountTarget) {
      this.requiredCountTarget.disabled = !showCount
      if (showCount) this.requiredCountTarget.required = true
      else this.requiredCountTarget.removeAttribute("required")
    }
  }
}
